export const analytics = {
  triggerAnalytics: () => {
    if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
      window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('store-search.search', {});
      window.LIFE_CYCLE_EVENT_BUS.trigger('header-store-search.find-store-click', {});
    }
  }
};